import { render } from "./LogoLimaTec.vue?vue&type=template&id=0a165ca4&scoped=true&ts=true"
import script from "./LogoLimaTec.vue?vue&type=script&lang=ts"
export * from "./LogoLimaTec.vue?vue&type=script&lang=ts"

import "./LogoLimaTec.vue?vue&type=style&index=0&id=0a165ca4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a165ca4"]])

export default __exports__